export default __webpack_public_path__ + "static/media/mail.8c0e0eff.svg";